<template>
	<div class="hotelsws">
		<div class="infinite-loading-containerss" >
			<i class="loading-defaultss"></i>
		</div>
	</div>
</template>
<script>

	export default{ 

	 	data(){
			return {
				isBookSuccess:false,
				OrderNO:'',
				isSubmited:true
			}
	 	},
	
	 	methods:{
			payByWX(code,orderNO){
				var that=this; 
				that.isSubmited=false;
			 	var param={
					orderNO:orderNO,
					code:code
				}
				this.getRequest({
						url:this.Api.getPresalePayParam, 
						params:param
					}).then(res => {
					   that.dao.set('thisBookingOrderNO','');
					   if(res&&res.IsSuccess){
					   	   that.isSubmited=true;					   	 
					   	    var config=res;
						    var location=window.location.href;
						    var protocol = window.location.protocol + '//';
						  

					   	    window.location.href=protocol+that.Api.domain+'/wxPayProxy.html?appId='+config.Result.AppID+'&timeStamp='+config.Result.TimeStamp+'&nonceStr='+config.Result.Nonce+'&package='+config.Result.Package+'&signType='+config.Result.SignType+'&paySign='+config.Result.Sign+'&OrderNO='+that.OrderNO+'&isPreSalePay=true'+'&url='+location;
					   }else{
						   that.error({title:'提示',content:res.Msg});
					   	   window.location.href=window.location.origin+'/#/presaleOrderDetails?OrderNO='+that.OrderNO;
					   }
				});
			}
	 	},
	 	mounted(){
	 		this.OrderNO=this.dao.get('thisBookingOrderNO');
	 
			var code=this.$route.query.code;
			var protocol = window.location.protocol + '//';
			var location=window.location.href;
			var that=this;
			
			if(!code){
				// alert('no code')
			  	window.location.href=protocol+that.Api.domain+'/getBaseWXCode.html?path=presaleWxPay'+'&url='+location;
			}else {
				
				this.payByWX(code,this.OrderNO);
			}

	 	}
	}
</script>
<style scoped>
.infinite-loading-containerss {
    display: inline-block;
    margin: 15px 0;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    border-radius: 50%;
    border:1px solid #999;
    -webkit-animation:ease loading-rotatings 1.5s infinite;
    animation: ease loading-rotatings 1.5s infinite;
    position: relative;
    left: 50%;
    margin-left: -14px;
}
.loading-defaultss{
    position: relative;
}
.loading-defaultss:before{
   
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
	margin-top: -3px;
    margin-left: 11px;
    width: 6px;
    height: 6px;
    background-color: #999;
    border-radius: 50%;
}
.hotelsws{
    padding-top: 50%;
}
 @-webkit-keyframes loading-rotatings{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
@keyframes loading-rotatings{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/wxPay.vue